import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

interface ThankYouPageProps {
  backgroundColor?: string;
  body: string;
  formHeight?: number;
  isModal?: boolean;
  isPreview?: boolean;
  isUsedOnPages?: boolean;
  textColor?: string;
  title: string;
  uid: string;
}
export const ThankYouPage = ({
  title,
  body,
  textColor,
  backgroundColor,
  uid,
  isPreview = false,
  isUsedOnPages = false,
  formHeight,
  isModal = false,
}: ThankYouPageProps) => (
  <div
    id={`thank-you-${uid}`}
    style={{
      height: formHeight,
      backgroundColor: backgroundColor,
    }}
    className={classNames(
      "flex size-full flex-col items-center justify-center gap-2 px-8 py-12 text-center",
      {
        "border-primary max-h-[440px] rounded-lg border": isPreview,
        "!pt-0": isModal,
        "max-w-[600px]": !isUsedOnPages,
      },
    )}
  >
    {textColor && (
      <style>{`#thank-you-${uid} h4, #thank-you-${uid} p { color: ${textColor}; }`}</style>
    )}
    <Typography.TitleMd>{title}</Typography.TitleMd>
    <Typography.BodyMd>{body}</Typography.BodyMd>
  </div>
);
